import axios from 'axios';
import './http';
import { getSelectedCompanyId } from '../utils/selectedCompany';
import { getProducts } from './productApi';
import { loadValidatedPosCatalog } from '../utils/posCatalogCache';
const API_URL = process.env.REACT_APP_API_URL || 'https://backend.chamafruits.com';
export const getPosCatalog = (branchId, onProgress) => loadValidatedPosCatalog({
  companyId: getSelectedCompanyId(), branchId, onProgress,
  fetchHash: async () => (await axios.get(`${API_URL}/branch/${branchId}/product/catalog/hash`)).data,
  fetchSnapshot: async () => (await axios.get(`${API_URL}/branch/${branchId}/product/catalog/snapshot`)).data,
  fetchLegacy: () => getProducts(branchId, { pageSize: 0 }),
});
